import { createSlice } from '@reduxjs/toolkit';

const userStatusSlice = createSlice({
  name: 'userStatus',
  initialState: { isAuthorized: true, isAuthenticated: true },
  reducers: {
    updateUserStatus(draft, action) {
      return { ...draft, ...action.payload };
    },
  },
});

export const { updateUserStatus } = userStatusSlice.actions;

export default userStatusSlice.reducer;

export const userStatusSelector = (state) => state.userStatus;
